import React from 'react'
import { Field, ErrorMessage} from 'formik'


const Input = (props) => {
    const {label, name, placeholder, ...rest } = props
    return (
        <div className="form-control">
            
            <Field id={name} name={name} {...rest} placeholder={placeholder}/>
            <span className="error">
            <ErrorMessage name={name} />
            </span>
        </div>
    )
}

export default Input
